import { FC, FormEvent, HTMLAttributes } from 'react';
import { RadioGroup, RadioBtn } from 'src/UI';
import { OptionType, OptionsType, ValuesType } from '.';

interface IRadioFieldProps extends HTMLAttributes<HTMLFieldSetElement> {
	/** Наименование поля */
	name: string;
	/** Только для чтения */
	disabled?: boolean;
	/** Множественное значение */
	multiple?: boolean;
	/** Расположения селектов */
	dir?: 'row' | 'col';
	/** Массив с вариантами */
	options?: OptionsType;
	/** Значение поля */
	value: ValuesType;
	/** Флаг не валидности поля - подсвечивает кнопки красным */
	isInvalid?: boolean;
	/**
	 * Вызывается при попытки изменить значение поля
	 * @param value Новое значение
	 * @param option Изменяемая опция
	 */
	onChangeValue?: (value: ValuesType, option: OptionType) => void;
}

/**  */
const RadioField: FC<IRadioFieldProps> = (props) => {
	const {
		name,
		options = [],
		value,
		onChangeValue,
		multiple = false,
		isInvalid = false,
		...otherProps
	} = props;

	/**  */
	const onChangeHandler = (
		e: FormEvent<HTMLInputElement>,
		item: OptionType,
	) => {
		e.stopPropagation();
		if (!onChangeValue) {
			return;
		}
		if (multiple) {
			if (!Array.isArray(value)) {
				throw new Error('Multiple Radio - value is not array!');
			}
			let newValue = Array.from(value);
			if (newValue.includes(item.value)) {
				newValue = value.filter((v) => {
					return v !== item.value;
				});
			} else {
				newValue.push(item.value);
			}
			onChangeValue(newValue, item);
		} else if (value !== item.value) {
			onChangeValue(item.value, item);
		}
	};

	/**  */
	const isChecked = (item: OptionType) => {
		if (multiple && Array.isArray(value)) {
			return value.includes(item.value);
		}
		return value === item.value;
	};

	/**  */
	const renderItem = (item: OptionType, index: number) => {
		return (
			<RadioBtn
				key={name + '-' + item.value + '_' + index}
				name={name}
				value={item.value}
				multiple={multiple}
				label={item.label}
				isInvalid={isInvalid}
				onChange={(e) => {
					return onChangeHandler(e, item);
				}}
				checked={isChecked(item)}
			/>
		);
	};

	return (
		<RadioGroup id={name} {...otherProps}>
			{options.map(renderItem)}
		</RadioGroup>
	);
};

export default RadioField;
